import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SessionsListComponent } from './list/sessions-list.component';
import { SessionsComponent } from './sessions.component';
import { SessionsCreateComponent } from './create/session-create.component';
import { SessionsEditComponent } from './edit/session-edit.component';
import { SessionsEmailComponent } from './email/email.component';
import { AuthGuard } from '../auth/auth.guard';
import { SessionsFeaturesComponent } from './features/features.component';
import { SessionsRegistrationComponent } from './registration/registration.component';
import { SessionsCustomizationComponent } from './customization/customization.component';
import { SessionsUsersComponent } from './users/users.component';
import { SessionsLinksComponent } from './links/links.component';
import { SessionsGenericLoginComponent } from './generic_login/generic_login.component';
import { SessionResolver, SessionsResolver } from './sessions.resolver';
import { SessionsManageMeEventComponent } from './manage-my-event/manage-my-event.component';
import { ReplayPublishComponent } from './replay/replay.component';
import { ThemeResolver } from '../../theme/theme.resolver';
import { StatsComponent } from './stats/stats.component';

const routes: Routes = [
  {
    path: 'sessions',
    redirectTo: 'sessions/list',
    pathMatch: 'full',
    resolve: { theme: ThemeResolver }
  },
  {
    path: 'sessions/create',
    component: SessionsCreateComponent,
    canActivate: [AuthGuard],
    data: { title: 'sessions.create.title' },
    resolve: { theme: ThemeResolver }
  },
  {
    path: 'sessions/list',
    component: SessionsListComponent,
    canActivate: [AuthGuard],
    resolve: { data: SessionsResolver, theme: ThemeResolver },
    runGuardsAndResolvers: 'always',
    data: { title: 'sessions.list.title' }
  },
  {
    path: 'sessions/:id',
    component: SessionsComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    resolve: { data: SessionResolver, theme: ThemeResolver },
    data: { title: '$name' },
    children: [
      { path: '', redirectTo: 'general', pathMatch: 'prefix' },
      { path: 'general', component: SessionsEditComponent },
      { path: 'features', component: SessionsFeaturesComponent },
      { path: 'emails', component: SessionsEmailComponent },
      { path: 'ui', component: SessionsCustomizationComponent },
      { path: 'users', component: SessionsUsersComponent },
      { path: 'links', component: SessionsLinksComponent },
      { path: 'registration', component: SessionsRegistrationComponent },
      { path: 'generic_login', component: SessionsGenericLoginComponent },
      { path: 'manage_my_event', component: SessionsManageMeEventComponent },
      { path: 'replay', component: ReplayPublishComponent },
      { path: 'stats', component: StatsComponent }
    ]
  }
];

export const router: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// ./src/app/modules/sessions/sessions.routes.ts